"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacetFilterExpEvaluator = void 0;
const get_1 = __importDefault(require("lodash/get"));
const FacetFilterUtils_1 = require("./FacetFilterUtils");
const inferType = (value) => {
    if (value === "true") {
        return true;
    }
    if (value === "false") {
        return false;
    }
    const number = Number(value);
    // eslint-disable-next-line no-self-compare
    if (number === number) {
        return number;
    }
    return value;
};
const interpolate = (item, facets, references) => {
    const inferred = inferType(item);
    if (typeof inferred === "string") {
        const [isRef, refValue] = (0, FacetFilterUtils_1.parseRef)(inferred, references);
        if (isRef) {
            return refValue;
        }
        const underscoreIndex = inferred.indexOf("_");
        if (underscoreIndex > -1) {
            const facetKey = inferred.substring(0, underscoreIndex);
            const facet = facets === null || facets === void 0 ? void 0 : facets[facetKey];
            if (facet != null) {
                const facetProp = inferred.substring(underscoreIndex + 1);
                const subPropPos = facetProp.indexOf(".");
                if (subPropPos > -1) {
                    return (0, get_1.default)((0, get_1.default)(facet, [facetProp.substring(0, subPropPos)]), [facetProp.substring(subPropPos + 1)]);
                }
                return (0, get_1.default)(facet, facetProp);
            }
        }
    }
    return inferred;
};
class FacetFilterExpEvaluator {
    constructor(schema) {
        this.operators = {};
        this.spacifyReplacements = [];
        schema.concat([[[",", (left, right) => [].concat(left, right)]]]).forEach((group, precedence) => group.forEach(([operator, operate]) => {
            this.operators[operator] = { precedence, operate };
        }));
        Object.keys(this.operators)
            .concat("(", ")")
            .forEach((op) => {
            const searchValue = /^[a-z]/i.test(op) ? `\\s+${(0, FacetFilterUtils_1.escapeRegExp)(op)}\\s*` : `\\s*${(0, FacetFilterUtils_1.escapeRegExp)(op)}\\s*`;
            this.spacifyReplacements.push({
                search: new RegExp(searchValue, "g"),
                replace: ` ${op} `,
            });
        });
    }
    spacify(exp) {
        let result = exp;
        this.spacifyReplacements.forEach((replacement) => {
            result = result.replace(replacement.search, replacement.replace);
        });
        return result.trim();
    }
    tokenize(exp) {
        return this.spacify(exp).split(/\s+/);
    }
    infixToPostfix(exp) {
        var _a;
        const result = [];
        const stack = [];
        const tokens = this.tokenize(exp);
        for (let i = 0; i < tokens.length; i += 1) {
            const token = tokens[i];
            if (token === "(") {
                stack.push(token);
            }
            else if (token === ")") {
                while (stack.length && stack[stack.length - 1] !== "(") {
                    result.push(stack.pop());
                }
                const openParentheses = stack.pop();
                if (openParentheses !== "(") {
                    throw new Error("Unexpected )");
                }
            }
            else if (this.operators[token] != null) {
                while (this.operators[token].precedence >= ((_a = this.operators[stack[stack.length - 1]]) === null || _a === void 0 ? void 0 : _a.precedence)) {
                    result.push(stack.pop());
                }
                stack.push(token);
            }
            else {
                result.push(token);
            }
        }
        while (stack.length) {
            if (stack[stack.length - 1] === "(") {
                throw new Error("Expecting )");
            }
            result.push(stack.pop());
        }
        return result;
    }
    eval(exp, references, facets) {
        const stack = [];
        const postfix = this.infixToPostfix(exp);
        postfix.forEach((token) => {
            if (this.operators[token] != null) {
                const params = [];
                const { operate } = this.operators[token];
                for (let p = 0; p < operate.length; p += 1) {
                    params.unshift(stack.pop());
                }
                stack.push(operate(...params));
            }
            else {
                const interpolated = interpolate(token, facets, references);
                stack.push(interpolated);
            }
        });
        return stack.pop();
    }
}
exports.FacetFilterExpEvaluator = FacetFilterExpEvaluator;
